import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    roles: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_ROLE_SELECT_IDS (store, ids) {
      store.roles.selectIds = ids
    },
    REMOVE_ROLE_SELECT_IDS (store, ids) {
      store.roles.selectIds = store.roles.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_ROLE_SELECT_ID (store, id) {
      store.roles.selectId = id
    },
    SET_ROLE_FILTERS (store, filters) {
      store.roles.filters = filters
    },
    SET_ROLE_PAGINATE (store, val) {
      store.roles.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getRoles: (store, getters) => {
      return store.roles.selectIds.map((id) => {
        return getters['entities/roles/find'](id)
      })
    },
    getRolesFilters: (store, getters) => {
      return store.roles.filters
    },
    getRolesPaginate: (store, getters) => {
      return store.roles.paginate
    },
    getRole: (store, getters) => {
      return getters['entities/roles/find'](store.roles.selectId) || {}
    }
  },
  actions: {
    /*
    selectRoles
    */
    selectRoles ({commit, dispatch, getters, state}, filters) {
      return dispatch('getRoles', filters)
      .then((response) => {
        commit('SET_ROLE_FILTERS', filters)
        commit('SET_ROLE_PAGINATE', response)
        commit('SET_ROLE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectRoles
    */
    refreshSelectRoles ({commit, dispatch, getters, state}) {
      return dispatch('selectRoles', getters.getRolesFilters)
    },
    /*
    selectRole
    */
    selectRole ({commit, dispatch, getters, state}, id) {
      return dispatch('getRoleById', id)
      .then((response) => {
        commit('SET_ROLE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getRoles
    */
    getRoles ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/roles`, {params: filters})
      .then((response) => {
        return dispatch('entities/roles/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.roles || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getRoleById
    */
    getRoleById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/roles/${id}`)
      .then((response) => {
        return dispatch('entities/roles/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.roles[0]
      })
    },
    /*
    createRole
    */
    createRole ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/roles`, data)
      .then((response) => {
        return dispatch('entities/roles/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.roles[0]
      })
    },
    /*
    updateRole
    */
    updateRole ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/roles/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/roles/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.roles[0]
      })
    },
    /*
    deleteRole
    */
    deleteRole ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/roles/${id}`)
      .then((response) => {
        commit('REMOVE_ROLE_SELECT_IDS', [id])
        dispatch('entities/roles/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Role.js